module.exports = __webpack_public_path__ + "static/media/image23.d12483a9.JPG";